import { flightsSessionStore } from "./browser-storage.js";
export const MARKETING_TRACKING_PARAMS = [
    "ext-src",
    "adplat",
    "aid",
    "label",
    "ext-origin",
    "ext-fwd",
    "ext-tr",
    "salesCountry",
    "salesCurrency",
    "distribution_id",
    "gclid",
    "gbraid"
];
export const getMarketingTrackingVariable = (trackingParam) => {
    const storedTrackingParam = flightsSessionStore && flightsSessionStore.get(trackingParam);
    if (storedTrackingParam && trackingParam == "aid") {
        return Number(storedTrackingParam);
    }
    else {
        return storedTrackingParam;
    }
};
